// import{CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
// import{Injectable} from '@angular/core';

// @Injectable()
// export class AuthGuard implements CanActivate{
//     canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
//         return false;
//     }
// }

import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';


@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate() {
        if (!localStorage.getItem('token_login')) {
            this.router.navigate(['/login']);
        }
        return true;
    }

}



// WEBPACK FOOTER //
// C:/www/onetouchSuperAdmin/src/app/auth/auth-guar.service.ts